module.exports = __webpack_public_path__ + "img/checkbox-blank.2000a64c.svg";